import { render, staticRenderFns } from "./OpenDemoDlg.vue?vue&type=template&id=63cc2bc8"
import script from "./OpenDemoDlg.vue?vue&type=script&lang=ts"
export * from "./OpenDemoDlg.vue?vue&type=script&lang=ts"
import style0 from "./OpenDemoDlg.vue?vue&type=style&index=0&id=63cc2bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports